module.exports = __webpack_public_path__ + "img/commission.1e3ee2d2.png";